import { render, staticRenderFns } from "./CreateOrderBatch.vue?vue&type=template&id=c4d16594&scoped=true&"
import script from "./CreateOrderBatch.vue?vue&type=script&lang=js&"
export * from "./CreateOrderBatch.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderBatch.vue?vue&type=style&index=0&id=c4d16594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d16594",
  null
  
)

export default component.exports